var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.has_store_data
    ? _c(
        "div",
        {
          staticClass:
            "\n    waf-component waf-listing\n    khabar-listing\n    widget-layout-185\n    match-tips-listing\n  ",
        },
        [
          _c(
            "div",
            { staticClass: "series_listing_header" },
            [
              _c("Breadcrumbs", {
                attrs: {
                  parentRoute: _vm.moduleRoute,
                  currentSeriesObj: _vm.getcurrentSeriesObj(),
                  currentSeries: _vm.selected_series,
                  sequence: [
                    { type: "base", page: "home" },
                    { type: "module", module: _vm.moduleRoute },
                    { type: "param", param: "sport_name" },
                  ],
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-select" },
                [
                  _c("select-list-custom", {
                    attrs: {
                      id: "series_selection_dd",
                      options: _vm.series_list,
                      selected: _vm.selected_series,
                      label: "category_name",
                      identifier: "series_code",
                      linkKey: "url",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "layout-wrapper" },
            [
              _c("div", { staticClass: "waf-head" }, [
                _c("h1", { staticClass: "title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.sportNameLabel ? _vm.sportNameLabel + ": " : ""
                      ) +
                      _vm._s(_vm.translations[_vm.pageHeadKey]) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.pageDescKey
                ? _c("div", { staticClass: "page_desc" }, [
                    _c("p", [_vm._v(_vm._s(_vm.getPageDesc()))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("gamezy-ad", {
                attrs: {
                  size: "mob_small",
                  ad_id: "mob_small-ad-1",
                  autoDetect: true,
                },
              }),
              _vm._v(" "),
              _vm.firstMatch
                ? _c(
                    "div",
                    {
                      class: [
                        "article-list",
                        { "featured-list": !_vm.is_mobile_view },
                      ],
                    },
                    [
                      _c("match-list-article-box", {
                        attrs: {
                          article: _vm.firstMatch,
                          listing_module: _vm.listingModules[_vm.pageHeadKey],
                          headline_keys: _vm.headlineKeys[_vm.pageHeadKey],
                          size: "560",
                          isFirstTile: true,
                          showDreamTeamImg: _vm.showDreamTeamImg,
                          showVideoImg: _vm.showVideoImg,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "article-list",
                    { "related-list": !_vm.is_mobile_view },
                  ],
                  attrs: { id: "scrollableWrapper" },
                },
                _vm._l(_vm.restMatches, function (mat, index) {
                  return _c("match-list-article-box", {
                    key: mat.rn,
                    attrs: {
                      article: mat,
                      listing_module: _vm.listingModules[_vm.pageHeadKey],
                      headline_keys: _vm.headlineKeys[_vm.pageHeadKey],
                      size: "360",
                      isFirstTile: false,
                      showDreamTeamImg: _vm.showDreamTeamImg,
                      showVideoImg: _vm.showVideoImg,
                      lazyImgType:
                        !_vm.firstMatch && index == 0 ? null : "rect",
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm.totalCount > 0
                ? _c("pagination", {
                    attrs: {
                      currentPage: _vm.page_number,
                      recordsPerView: _vm.pagesize,
                      totalRecords: _vm.totalCount,
                      baseUrl: _vm.getPaginationBaseUrl(),
                      isLoadMoreDisabled: _vm.isLoadMoreDisabled,
                      onPageChange: _vm.onPageChange,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.no_match_tips_list,
                      expression: "no_match_tips_list",
                    },
                  ],
                  staticClass: "no-contest-section",
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "no-contest-text" }, [
                    _c("p", { staticClass: "text" }, [
                      _vm._v(
                        _vm._s(_vm.translations.no_match_tips_list_text_1)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text" }, [
                      _vm._v(
                        _vm._s(_vm.translations.no_match_tips_list_text_2)
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-contest-thumbnail" }, [
      _c("img", {
        attrs: {
          src: "/static-assets/images/cssimages/no-contest-cham.png",
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }